import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PermissaoInserirComponent } from './permissao-inserir.component';


@NgModule({
    imports: [RouterModule.forChild([
        { path: '', component: PermissaoInserirComponent }
    ])],
    exports: [RouterModule]
})
export class PermissaoInserirRoutingModule { }
